/**
 * Helpers for the single-check "clear / no matches" result screen (#10116).
 */

export const EXCLUSION_SOURCES_CHECKED =
  "OIG LEIE · SAM (GSA) · State Medicaid (all 50) · OFAC SDN · TRICARE · Medicare Opt-Out";

export const EXCLUSION_SOURCE_FRESHNESS_PREVIEW =
  "OIG LEIE · SAM (GSA) · State Medicaid (all 50)";

export const EXCLUSION_SOURCE_FRESHNESS_ALL = [
  "OIG LEIE",
  "SAM (GSA)",
  "State Medicaid (all 50)",
  "OFAC SDN",
  "TRICARE",
  "Medicare Opt-Out",
] as const;

export function buildClearIdentifierParts(criteria: {
  npi?: string;
  ssn?: string;
  license?: string;
}): string[] {
  const parts: string[] = [];
  const npi = String(criteria.npi || "").trim();
  const ssn = String(criteria.ssn || "").replace(/\D/g, "");
  const license = String(criteria.license || "").trim();
  if (npi) parts.push(`NPI ${npi}`);
  if (ssn) parts.push(ssn.length >= 4 ? `SSN ***-**-${ssn.slice(-4)}` : "SSN provided");
  if (license) parts.push(`License ${license}`);
  return parts;
}

/** Subtitle: identifier(s) · Type · matched on identifier */
export function buildClearResultSubtitle(args: {
  npi?: string;
  ssn?: string;
  license?: string;
  subjectType: string;
}): string {
  const parts = buildClearIdentifierParts(args);
  parts.push(args.subjectType || "Subject");
  parts.push("matched on identifier");
  return parts.join(" · ");
}

export function formatOperatorName(user: {
  display_name?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  username?: string;
} | null): string {
  if (!user) return "Unknown operator";
  const display = String(user.display_name || "").trim();
  if (display) return display;
  const first = String(user.first_name || "").trim();
  const last = String(user.last_name || "").trim();
  if (first && last) {
    return `${first.charAt(0)}. ${last}`;
  }
  if (first || last) return first || last;
  const email = String(user.email || "").trim();
  if (email) return email;
  const username = String(user.username || "").trim();
  return username || "Unknown operator";
}

export function formatCheckedAtLine(checkedAt: Date | null, operator: string): string {
  if (!checkedAt) return operator ? `by ${operator}` : "";
  // Mockup: "2026-07-20 09:14 UTC by A. Kaur"
  const stamp = checkedAt
    .toISOString()
    .replace("T", " ")
    .replace(/:\d{2}\.\d{3}Z$/, " UTC");
  return operator ? `${stamp} by ${operator}` : stamp;
}
